import { useTheme } from "@emotion/react";
import { ImageList, ImageListItem, useMediaQuery } from "@mui/material";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import List from "@mui/material/List";
import { createTheme } from "@mui/material/styles";
import * as React from "react";

const theme = createTheme();

export default function ProfilePictureSelector({ onChange, data = {} }) {
  const [profilePicture, setProfilePicture] = React.useState(
    data.siteProfilePicture
  );

  const theme = useTheme();
  const isXsBreakPoint = useMediaQuery(theme.breakpoints.down("sm"));

  const cols = isXsBreakPoint ? 1 : 2;
  const images = data.images;

  const isProfilePicture = (item) => {
    return item === profilePicture;
  };

  return (
    <Container sx={{ mb: "4.5rem" }} component="main" maxWidth="xs">
      <Box component="form" sx={{ mt: 1 }}>
        {images && images.length > 0 && (
          <Box sx={{ pt: "1rem", pb: "1rem", flexGrow: 1 }}>
            <List>
              <ImageList
                variant="masonry"
                cols={cols}
                gap={8}
                style={{
                  marginBottom: "0",
                }}
              >
                {images.map((item, index) => (
                  <ImageListItem
                    key={index}
                    style={{
                      //greyscale filter
                      filter: isProfilePicture(item) ? "grayscale(1)" : "none",
                    }}
                    onClick={() => {
                      if (isProfilePicture(item)) {
                        return;
                      } else {
                        setProfilePicture(item);
                        onChange(item);
                      }
                    }}
                  >
                    <img
                      srcSet={`${item}?w=248&fit=crop&auto=format&dpr=2 2x`}
                      src={`${item}?w=248&fit=crop&auto=format`}
                      // alt={item}
                      loading="lazy"
                      style={{
                        borderRadius: "1rem",
                      }}
                    />
                  </ImageListItem>
                ))}
              </ImageList>
            </List>
          </Box>
        )}
      </Box>
    </Container>
  );
}
